<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>招聘管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/position/table'}">职位列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel :show-header="false">
      <el-form ref="form"
               :model="form"
               :rules="searchRules"
               label-width="120px"
               class="demo-ruleForm">
        <el-row class="text item">
          <el-col :span="24">
            <h2>基本信息</h2>
            <hr>
          </el-col>
          <el-form-item prop="up_date"
                        label="发布时间:">
            <el-col :span="24">
              <el-date-picker v-model="form.up_date"
                              type="date"
                              placeholder="开始日期"
                              value-format="yyyy-MM-dd">
              </el-date-picker>
              ~
              <el-date-picker v-model="form.down_date"
                              type="date"
                              placeholder="结束日期"
                              value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item prop="industry_type"
                        label="行业大类:">
            <el-select v-model="form.industry_type"
                       placeholder="请选择行业大类">
              <el-option :label="industryType.keyword"
                         :value="industryType.id"
                         :key="index"
                         v-for="(industryType,index) in options.industry_type"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="position_type"
                        label="职位类型:">
            <el-select v-model="form.position_type"
                       placeholder="请选择职位类型">
              <el-option :label="positionType.keyword"
                         :value="positionType.id"
                         :key="index"
                         v-for="(positionType,index) in options.position_type"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="title"
                        label="岗位名称:">
            <el-input v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item prop="hire_number"
                        label="招聘人数:">
            <el-input v-model="form.hire_number"></el-input>
          </el-form-item>
          <el-form-item prop="address"
                        label="工作地点:">
            <el-input v-model="form.address"></el-input>
          </el-form-item>
          <el-form-item prop="area_id"
                        label="省市区:">
            <template slot-scope="scope">
              <el-select v-model="form.province_id"
                         filterable
                         remote
                         reserve-keyword
                         placeholder="请选择省"
                         @change="remoteCityMethod"
                         :loading="selectLoading"
                         auto-complete="province_id">
                <el-option v-for="item in options.province_id"
                           :key="item.id"
                           :label="item.name"
                           :value="parseInt(item.id)">
                </el-option>
              </el-select>&nbsp;&nbsp;&nbsp;&nbsp;
              <el-select v-model="form.city_id"
                         filterable
                         remote
                         reserve-keyword
                         placeholder="请选择市"
                         @change="remoteAreaMethod"
                         :loading="selectLoading"
                         auto-complete="cit_id">
                <el-option v-for="item in options.city_id"
                           :key="item.id"
                           :label="item.name"
                           :value="parseInt(item.id)">
                </el-option>
              </el-select>&nbsp;&nbsp;&nbsp;&nbsp;
              <el-select v-model="form.area_id"
                         filterable
                         remote
                         reserve-keyword
                         placeholder="请选择区"
                         :loading="selectLoading"
                         auto-complete="area_id">
                <el-option v-for="item in options.area_id"
                           :key="item.id"
                           :label="item.name"
                           :value="parseInt(item.id)">
                </el-option>
              </el-select>
            </template>
          </el-form-item>
          <el-form-item prop="employer_name"
                        label="发布单位:">
            <el-input v-model="form.employer_name"></el-input>
          </el-form-item>
        </el-row>
        <br>
        <el-row class="text item">
          <el-col :span="24">
            <h2>职位描述</h2>
            <hr>
          </el-col>
          <el-form-item label="工作时间:"
                        prop="position_period">
            <el-input v-model="form.position_period"></el-input>
          </el-form-item>
          <el-form-item label="工作班次:"
                        prop="working_shifts">
            <el-input v-model="form.working_shifts"></el-input>
          </el-form-item>
          <el-form-item label="工作时长:"
                        prop="working_hours">
            <el-input v-model="form.working_hours"></el-input>
          </el-form-item>
          <el-form-item label="性别要求:"
                        prop="gender">
            <el-select v-model="form.gender"
                       placeholder="请选择性别要求">
              <el-option :label="strgender.keyword"
                         :value="strgender.id"
                         :key="index"
                         v-for="(strgender,index) in options.gender"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年龄要求:"
                        prop="age_range">
            <el-input v-model="form.age_range"></el-input>
          </el-form-item>
          <el-form-item label="证件要求:"
                        prop="certificate">
            <el-input v-model="form.certificate"></el-input>
          </el-form-item>
          <el-form-item label="学历要求:"
                        prop="education">
            <el-select v-model="form.education"
                       placeholder="请选择学历要求">
              <el-option :label="streducation.keyword"
                         :value="streducation.id"
                         :key="index"
                         v-for="(streducation,index) in options.education"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="婚姻状况:"
                        prop="marriage">
            <el-select v-model="form.marriage"
                       placeholder="请选择学历要求">
              <el-option :label="strmarriage.keyword"
                         :value="strmarriage.id"
                         :key="index"
                         v-for="(strmarriage,index) in options.marriage"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工作经验:"
                        prop="working_experience">
            <el-input v-model="form.working_experience"></el-input>
          </el-form-item>
          <el-form-item label="补充说明:"
                        prop="other_requirements">
            <el-input type="textarea"
                      v-model="form.other_requirements"></el-input>
          </el-form-item>
        </el-row>
        <br/>
        <el-row class="text item">
          <el-col :span="24">
            <h2>薪资福利</h2>
            <hr>
          </el-col>
          <el-form-item label="基本薪资:"
                        prop="salary">
            <el-select v-model="form.salary"
                       placeholder="请选择薪资范围">
              <el-option label="0"
                         :value="-1"
                         :key="-1"></el-option>
              <el-option :label="type.keyword"
                         :value="type.id"
                         :key="index"
                         v-for="(type,index) in options.salary"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="薪资方式:"
                        prop="salary_type">
            <el-select v-model="form.salary_type"
                       placeholder="请选择薪资方式">
              <el-option :label="type.keyword"
                         :value="type.id"
                         :key="index"
                         v-for="(type,index) in options.salary_type"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="提成机制:"
                        prop="commission">
            <el-input v-model="form.commission"></el-input>
          </el-form-item>
          <el-form-item label="季度奖金:"
                        prop="quarterly_bonus">
            <el-input v-model="form.quarterly_bonus"></el-input>
          </el-form-item>
          <el-form-item label="社保缴纳:"
                        prop="insurance">
            <el-select v-model="form.insurance"
                       placeholder="请选择社保缴纳">
              <el-option :label="strinsurance.keyword"
                         :value="strinsurance.id"
                         :key="index"
                         v-for="(strinsurance,index) in options.insurance"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="加班补助:"
                        prop="overtime_pay">
            <el-input v-model="form.overtime_pay"></el-input>
          </el-form-item>
          <el-form-item label="餐饮补助:"
                        prop="meal_allowance">
            <el-input v-model="form.meal_allowance"></el-input>
          </el-form-item>
          <el-form-item label="交通补助:"
                        prop="commute_allowance">
            <el-input v-model="form.commute_allowance"></el-input>
          </el-form-item>
          <el-form-item label="话费补助:"
                        prop="phone_allowance">
            <el-input v-model="form.phone_allowance"></el-input>
          </el-form-item>
          <el-form-item label="其他福利:"
                        prop="welfare">
            <el-input v-model="form.welfare"></el-input>
          </el-form-item>
          <el-form-item label="结算方式:"
                        prop="settlement_strtype">
            <el-select v-model="form.settlement_type"
                       placeholder="请选择结算方式">
              <el-option :label="settlementStrtype.keyword"
                         :value="settlementStrtype.id"
                         :key="index"
                         v-for="(settlementStrtype,index) in options.settlement_type"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="结算时间:"
                        prop="settlement_time">
            <el-select v-model="form.settlement_time"
                       placeholder="请选择结算时间">
              <el-option :label="settlementStrtime.keyword"
                         :value="settlementStrtime.id"
                         :key="index"
                         v-for="(settlementStrtime,index) in options.settlement_time"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       @click="onSubmitForm()">修改
            </el-button>
            <router-link :to="{ path: '/position/pending-check-detail/' + form.id + '?creator=' + form.creator }">
              <el-button>取消</el-button>
            </router-link>
          </el-form-item>
        </el-row>
      </el-form>
    </layout-panel>

  </div>
</template>

<script>
import { searchRules } from '../position.rules.js'

export default {
  data () {
    return {
      creator: this.$route.query.creator,
      searchRules,
      selectLoading: false,
      form: {
        id: this.$route.params.id,
        up_date: null,
        down_date: null,
        industry_type: null,
        position_type: null,
        title: null,
        hire_number: 0,
        address: null,
        employer_name: null,
        position_period: null,
        working_shifts: null,
        working_hours: null,
        gender: null,
        age_range: null,
        certificate: null,
        education: null,
        marriage: null,
        working_experience: null,
        other_requirements: null,
        salary: null,
        salary_type: null,
        commission: null,
        quarterly_bonus: null,
        insurance: null,
        overtime_pay: null,
        meal_allowance: null,
        commute_allowance: null,
        phone_allowance: null,
        welfare: null,
        settlement_type: null,
        settlement_time: null,
        province_id: null,
        city_id: null,
        area_id: null,
        creator: null,
      },
      options: {
        industry_type: [],
        position_type: [],
        salary: [],
        salary_type: [],
        gender: [],
        settlement_type: [],
        settlement_time: [],
        education: [],
        marriage: [],
        insurance: [],
        province_id: [],
        city_id: [],
        area_id: [],
      },
    }
  },
  computed: Vuex.mapState({}),
  created () {
    request.all.page([
      request('getProvinceList'),
      request('editPostionOptions'),
      request('getPostionForm', this.form.id),
    ]).then(([province, options, form]) => {
      (({data}) => {
        this.options.province_id = data
      })(province)

      ;(({data}) => {
        filter.setLoop(this.options, data)
      })(options)

      ;(({data}) => {
        filter.setLoop(this.form, data)
        request.all.page([
          request('getCityList', this.form.province_id),
          request('getAreaList', this.form.city_id),
        ]).then(([city, area]) => {
          (({data}) => {
            this.options.city_id = data
          })(city)

          ;(({data}) => {
            this.options.area_id = data
          })(area)
        })
      })(form)
    })
  },
  methods: {
    ...Vuex.mapActions(['getPostionForm', 'editPostionOptions', 'modifyPostion', 'getProvinceList', 'getCityList', 'getAreaList']),

    onSubmitForm () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.form.salary_type === 3) {
            this.form.salary = 0
          } else if (this.form.salary === -1) {
            this.$message.error('请选择基本薪资')
            return false
          }

          if (!this.form.down_date) {
            this.$message.error('请选择发布下线时间')
            return false
          }

          return request.common('modifyPostion', this.form).then((data) => {
            this.$router.push({path: '/position/pending-check-detail/' + this.form.id + '?creator=' + this.form.creator})
          })
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    remoteCityMethod (id) {
      request.common('getCityList', id).then((data) => {
        this.options.city_id = data.data
        this.form.city_id = ''
        this.form.area_id = ''
      })
    },
    remoteAreaMethod (id) {
      request.common('getAreaList', id).then((data) => {
        this.options.area_id = data.data
        this.form.area_id = ''
      })
    },
  },

}
</script>



// WEBPACK FOOTER //
// src/views/position/pages/PositionPendingAuditForm.vue